"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./index'));



//////////////////
// WEBPACK FOOTER
// /app/~/ng2-dragula/ng2-dragula.js
// module id = ../../../../ng2-dragula/ng2-dragula.js
// module chunks = 16